import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OnboardingChecklistModule, OnboardingPersonalInfoModule } from '@core/widgets/onboarding-widget/shared';
import { OnboardingWidgetComponent } from './onboarding-widget.component';
@NgModule({
  declarations: [OnboardingWidgetComponent],
  imports: [CommonModule, OnboardingPersonalInfoModule, OnboardingChecklistModule],
  exports: [OnboardingWidgetComponent],
})
export class OnboardingWidgetModule {}
